import { useState } from "react"

export const ProfileState = () => {
    const [pinfo, setPinfo] = useState({
        firstName:'',
        lastName:'',
        middleName:'',
        suffix:'',
        otherInfo: {
            gender:'',
            birthdate:'',
            civilStatus:''
        },
        profile:{
            cover: null,
            profile: null
        }
    })
    const [isProgress, setIsProgress] = useState(0)
    const [isLoader, setIsLoader] = useState({type:'', status:false})
    return {
        pinfo : { data: pinfo , set: setPinfo},
        isProgress: {data: isProgress, set: setIsProgress},
        isLoader: {data: isLoader, set: setIsLoader},
    }
}